import '../assets/root.css';
import { jsx as e } from "react/jsx-runtime";
import m from "clsx";
import { forwardRef as i } from "react";
import { AlertContext as c } from "../context.js";
import { DEFAULT_SEVERITY as n } from "../utils.js";
const p = "_alert_17e2m_3", d = {
  alert: p
}, f = i((t, o) => {
  const { children: l, className: s, severity: r = n, ...a } = t;
  return /* @__PURE__ */ e(c.Provider, { value: { severity: r }, children: /* @__PURE__ */ e(
    "div",
    {
      ref: o,
      className: m(d.alert, s),
      role: "alert",
      ...a,
      "data-severity": r,
      children: l
    }
  ) });
});
f.displayName = "Alert";
export {
  f as Root
};
